<template>
  <div>
    <b-row>
      <b-col>
        <h5 class="text-secondary m-1">
          {{ "Kpi" }}:
          <v-icon v-if="loading" name="spinner" spin></v-icon>
        </h5>
      </b-col>
      <b-col>
        <ulu-date-picker
          class="float-right m-1"
          range
          v-model="range"
          lang="en"
          format="DD.MM.YYYY"
          :placeholder="$t('globals.all')"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-table
          class="m-1"
          small
          :items="stats"
          :fields="fields" 
        >
          <template v-slot:cell(avg_vel10_sold)="row">
            <div v-if="row.item.avg_vel10_sold != null">
              {{ currencyFormat(row.item.avg_vel10_sold) }}
            </div>
          </template>
          <template v-slot:cell(avg_velpro_sold)="row">
            <div v-if="row.item.avg_velpro_sold != null">
              {{ currencyFormat(row.item.avg_velpro_sold) }}
            </div>
          </template>
          <template v-slot:cell(avg_vel10_lease)="row">
            <div v-if="row.item.avg_vel10_lease != null">
              {{ currencyFormat(row.item.avg_vel10_lease) }}
            </div>
          </template>
          <template v-slot:cell(avg_velpro_lease)="row">
            <div v-if="row.item.avg_velpro_lease != null">
              {{ currencyFormat(row.item.avg_velpro_lease) }}
            </div>
          </template>
          <template v-slot:cell(avg_connectivity)="row">
            <div v-if="row.item.avg_connectivity != null">
              {{ currencyFormat(row.item.avg_connectivity) }}
            </div>
          </template>
        </b-table>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import { mapActions, mapGetters } from "vuex";
import { currencyFormat } from "@/helpers/price";

export default {
  components: {
    "ulu-date-picker": DatePicker
  },
  data() {
    return {
      range: [null, null],
      formatedRange: [null, null],
      loading: false,
      stats: [],
      fields: [
        {
          key: "agent",
          label: this.$t("globals.agent"),
          sortable: true
        },
        {
          key: "no_inquiries",
          label: this.$t("globals.inquiries"),
          sortable: true
        },
        {
          key: "no_orders",
          label: this.$t("globals.orders"),
          sortable: true
        },
        {
          key: "no_devices",
          label: this.$t("globals.all_devices"),
          sortable: true
        },
        {
          key: "vel10_sold",
          sortable: true
        },
        {
          key: "velpro_sold",
          sortable: true
        },
       
        {
          key: "at4m_sold",
          sortable: true
        },
        
        {
          key: "twdashcam_sold",
          sortable: true
        },
        {
          key: "cmm1_sold",
          sortable: true
        },
        {
          key: "cmm3_sold",
          sortable: true
        },
        {
          key: "cmm4_sold",
          sortable: true
        },
        
        
        
       
        {
          key: "avg_connectivity",
          sortable: true
        }
      ]
    };
  },
  methods: {
    ...mapActions("axios_mod", ["simpleFetch"]),
    currencyFormat,
    fetchData() {
      const data = {
        query: `
          query {
            AgentsKpisRange (
              ${ this.formatedRange[0]
                ? 'from: "' +this.formatedRange[0] + '", to: "' + this.formatedRange[1] + '"'
                : ''
              }
            )
          }
        `
      };

      this.loading = true;
      this.simpleFetch({data, this_ref: this}).then((res) => {
        if (res) {
          this.stats = [];
          JSON.parse(res.AgentsKpisRange).forEach(e => {
            this.stats.push(JSON.parse(e))
          });
        }
      }).finally(()=>{
        this.loading = false;
      });
    }
  },
  computed: {
    ...mapGetters(["getThisYearRange","getUserSystem"])
  },
  watch: {
    getUserSystem: function() {
      this.fetchData();
    },
    range: function(newRange) {
      if (newRange[0] !== null && newRange[1] !== null) {
        let from = new Date(newRange[0]);
        let to = new Date(newRange[1]);

        from.setHours(from.getHours() + 1);
        to.setHours(to.getHours() + 25);

        this.formatedRange = [
          `${from.getFullYear()}-${from.getMonth()+1}-${from.getDate()}`,
          `${to.getFullYear()}-${to.getMonth()+1}-${to.getDate()}`
        ];

        this.fetchData()
      } else {
        this.formatedRange = [null, null];
        this.fetchData()
      }
    }
  },
  mounted() {
    this.range = this.getThisYearRange
    this.fetchData();
  }
};
</script>
